module.exports = __webpack_public_path__ + "static/media/kuro-tree-connect-ill.c2143ccf.svg";